import ContactPerson from "./ContactPerson";
import ContactList from "./ContactList";

interface FormContainerProps {
  contactList: any;
  onChangeContactList: Function;
  onDeleteContactList: Function;
  onAddContactList: Function;
  onChangePersonContact: Function;
  validated: boolean;
}

const FormContainer = ({
  contactList,
  onChangeContactList,
  onDeleteContactList,
  onAddContactList,
  onChangePersonContact,
  validated,
}: FormContainerProps) => {
  return (
    <>
      <ContactPerson
        validated={validated}
        onChangeContactPerson={onChangePersonContact}
      />
      <ContactList
        contactList={contactList}
        onChangeContactList={onChangeContactList}
        onDeleteContactList={onDeleteContactList}
        onAddContactList={onAddContactList}
        validated={validated}
      />
    </>
  );
};

export default FormContainer;
